module.exports = __webpack_public_path__ + "static/media/closeOrangeIcon.6e58dcaa.svg";